import classNames from 'classnames';
import qs from 'querystring';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Disclaimer from '../Disclaimer';
import Footer from '../Footer';
import Loader from '../../../components/Loader';
import NavBar, { View } from '../../../components/NavBar';
import NoCookies from '../NoCookies';
import PhoneInput from '../../../components/PhoneInput';
import { Button } from '../../../components/Button';
import { isNumberValid } from '../../../utils/phoneNumber';
import { useTheme } from '../../../hooks/common/useTheme';

import * as api from '../../../api';
import * as logger from '../../../logger';

import styles from '../index.module.css';

// Will be prac pref in future
const SUCCESS_MESSAGE = `Thanks, please continue to your provider's office, and complete the forms texted to you.`;
const ERROR_MESSAGE = `Thanks. We could not send to that number, but please continue to your appointment to be seen.`;

const RegistrationRequest: React.FC = () => {
  const [cellPhoneNumber, setCellPhoneNumber] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showResult, setShowResult] = useState<'success' | 'error'>();
  const { search } = useLocation();
  const { t } = useTranslation();
  const { isThemeLoading } = useTheme();

  // process optional ref code
  const { ref: refCodeRaw } = qs.parse(search.slice(1));
  const refCode = Array.isArray(refCodeRaw) ? refCodeRaw[0] : refCodeRaw;

  useEffect(() => {
    api.client.Previsit.createPrevisitLog({
      auditLog:
        api.Log.PrevisitAuditAction
          .PatientPrevisitNavigatedToMessageRequestPage,
      previsitLog: api.Log.PrevisitAction.NavigatedToMessageRequestPage,
      authenticationCode: refCode,
    });
  }, [refCode]);

  if (isThemeLoading) {
    return <Loader />;
  }

  const handleSubmit = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (!cellPhoneNumber) {
      alert(t('Please enter your phone number before submitting.'));
      return;
    }

    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      await api.client.Previsit.requestMessage(cellPhoneNumber, refCode);
    } catch (err) {
      logger.error(err);
      setIsSubmitting(false);
      return setShowResult('error');
    }

    setShowResult('success');
  };

  const cellPhoneValid = !!cellPhoneNumber && isNumberValid(cellPhoneNumber);

  return (
    <div className={styles.LoginWrapper}>
      <NavBar view={View.Login} />
      <div className={styles.Login}>
        <NoCookies />
        {showResult && (
          <div className={styles.Instructions}>
            {showResult === 'success' ? t(SUCCESS_MESSAGE) : t(ERROR_MESSAGE)}
          </div>
        )}

        {!showResult && (
          <>
            <div className={styles.Instructions}>
              {t('enterMobilePhoneNumberAssociatedWithRecords')}
            </div>
            <form onSubmit={handleSubmit}>
              <div
                className={classNames(styles.Inputs, styles.RegistrationInputs)}
              >
                <PhoneInput
                  label={t('enterMobilePhoneNumberAssociatedWithRecords')}
                  key="phone-number-input"
                  className={styles.Input}
                  value={cellPhoneNumber || ''}
                  placeholder={t('phoneNumber')}
                  saveFieldValue={() => {}}
                  updateFieldValue={setCellPhoneNumber}
                />
              </div>
              <Button
                id="sign-in-button"
                children={t('Continue')}
                type="submit"
                disabled={!cellPhoneValid || isSubmitting}
              />
            </form>
            <Disclaimer />
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default RegistrationRequest;
